/** @jsx jsx */
import {useState} from 'react'
import {jsx, css} from '@emotion/react'
import {logDplWithExtensionParams, EVENTS} from '../../util/dpl'
import Button from '../button'
import {colors} from '../../constants'
import {createMarkup} from '../../util/datoCmsDataFactory'

const SurveyUinstall = ({languageCode = 'en'}) => {
    const translations = {
        en: {
            title: 'Why did you uninstall our extension?',
            option1: 'There are not enough features',
            option2: 'The search results do not meet my expectations',
            option3: 'The extension caused a problem with a website, browser, or other software',
            option4: 'I no longer want Startpage to be my default search engine',
            option5: 'I have privacy concerns',
            option6: 'The extension does not use my saved Startpage.com settings',
            option7: 'Other (Specify in text box below)',
            description:
                'By clicking submit, you are sending your anonymous response to Startpage. Please see our <a href="https://www.startpage.com/en/search/privacy-policy.html" target="__blank" rel="noopener noreferrer" aria-label="privacy policy">privacy policy</a>.',
            buttonText: 'Submit',
            additionalFeedback: 'Any additional feedback?',
        },
        de: {
            title: 'Warum hast du die Erweiterung deinstalliert?',
            option1: 'Es gibt nicht genügend Funktionen',
            option2: 'Die Suchergebnisse haben nicht meinen Erwartungen entsprochen',
            option3: 'Die Erweiterung verursacht Probleme mit einer Website, einem Browser oder anderer Software',
            option4: 'Ich möchte Startpage nicht mehr als Standardsuchmaschine nutzen',
            option5: 'Ich habe Datenschutzbedenken',
            option6: 'Die Erweiterung verwendet meine Startpage-Einstellungen nicht',
            option7: 'Andere Gründe (bitte im Textfeld unten angeben)',
            description:
                "Indem du auf 'Senden' klickst, wird deine Antwort anonym an Startpage übermittelt. Bitte beachte unsere <a href='https://www.startpage.com/de/search/privacy-policy.html' target='__blank' aria-label='privacy policy'>Datenschutzhinweise.</a>",
            buttonText: 'Senden',
            additionalFeedback: 'Hast du zusätzliches Feedback?',
        },
        fr: {
            title: 'Pourquoi avez-vous désinstallé notre extension ?',
            option1: 'Il n’y a pas assez de fonctionnalités',
            option2: 'Les résultats de la recherche ne correspondent pas à mes attentes',
            option3: 'L’extension a causé un problème avec un site web, un navigateur ou d’autres logiciels',
            option4: 'Je ne veux plus que Startpage soit ma moteur de recherche par défaut',
            option5: 'Je ai des préoccupations concernant la confidentialité',
            option6: 'L’extension ne respecte pas mes paramètres de recherche Startpage.com',
            option7: 'Autre (spécifiez dans le champ texte ci-dessous)',
            description:
                "En cliquant sur 'Envoyer', vous envoyez votre réponse anonyme à Startpage. Veuillez consulter notre <a href='https://www.startpage.com/fr/search/privacy-policy.html' target='__blank' aria-label='privacy policy'>politique de confidentialité.</a>",
            buttonText: 'Envoyer',
            additionalFeedback: 'Vous avez des commentaires supplémentaires ?',
        },
    }

    const text = translations[languageCode]

    const [surveyData, setSurveyData] = useState({
        surveyReason: ``,
        surveyReasonText: ``,
    })

    const onSurveyInputChange = (e) => {
        const currentSelection = {}
        const {name, value} = e.target
        currentSelection[name] = value
        setSurveyData({
            ...surveyData,
            ...currentSelection,
        })
    }

    const onSurveySubmit = (event) => {
        event.preventDefault()
        const {surveyReason, surveyReasonText} = surveyData
        logDplWithExtensionParams(EVENTS.StartpageUninstallSurvey, {
            surveyReason,
            surveyReasonText,
        })
            .then(() => {
                window.location.href = 'https://www.startpage.com'
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error(`can't submit form: ${e}`)
            })
    }

    return (
        <div
            className="survey"
            css={css`
                max-width: 600px;
                margin: 0 auto;
                h4 {
                    font-weight: 600;
                    font-size: 20px;
                }
            `}
        >
            <h4>{text.title}</h4>
            <form
                onSubmit={onSurveySubmit}
                css={css`
                    display: flex;
                    flex-direction: column;
                    margin: 1rem 0 0 0;
                    .form-item {
                        margin: 0.75rem 0;
                        label {
                            display: flex;
                            align-items: baseline;
                        }
                        input {
                            font-size: 1rem;
                            margin-right: 1rem;
                            &:hover {
                                cursor: pointer;
                            }
                        }
                    }
                `}
            >
                <div className="form-item">
                    <label htmlFor="3">
                        <input id="3" type="radio" value="1" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option1}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="4">
                        <input id="4" type="radio" value="2" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option2}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="5">
                        <input id="5" type="radio" value="3" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option3}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="6">
                        <input id="6" type="radio" value="4" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option4}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="7">
                        <input id="7" type="radio" value="5" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option5}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="8">
                        <input id="8" type="radio" value="6" name="surveyReason" onChange={onSurveyInputChange} />{' '}
                        <span>{text.option6}</span>
                    </label>
                </div>
                <div className="form-item">
                    <label htmlFor="9">
                        <input
                            id="9"
                            type="radio"
                            value="7"
                            name="surveyReason"
                            onChange={onSurveyInputChange}
                            onMouseUp={() => {
                                setTimeout(() => {
                                    document.querySelector('#textarea').focus()
                                }, 0)
                            }}
                        />{' '}
                        {text.option7}
                    </label>
                </div>
                <h4
                    css={css`
                        margin: 2.5rem 0 1.5rem;
                    `}
                >
                    {text.additionalFeedback}
                </h4>
                <label htmlFor="textarea">
                    <textarea
                        onChange={onSurveyInputChange}
                        value={surveyData.surveyReasonText}
                        id="textarea"
                        name="surveyReasonText"
                        maxLength="256"
                        css={css`
                            appearance: none;
                            width: 100%;
                            color: #3b435c;
                            border-radius: 4px;
                            border: 1px solid ${colors.midnight};
                            font-family: inherit;
                            padding: 7px;
                            max-width: 100%;
                            height: 3.875rem;
                            background-color: ${colors.whisperLight};
                            font-size: 0.875rem;
                            &:focus {
                                border: 1px solid ${colors.midnight};
                                outline: none;
                            }
                        `}
                    />
                </label>
                <div>
                    <p
                        css={css`
                            font-size: 0.875rem;
                            color: ${colors.midnightMedium};
                            margin: 1rem 0;
                            @media (max-width: 950px) {
                                margin-bottom: 1rem;
                                max-width: 400px;
                            }
                            a {
                                color: ${colors.brandBlue};
                                transition: color 0.3s ease;

                                &:hover {
                                    color: ${colors.brandBlueLight};
                                }
                            }
                        `}
                        dangerouslySetInnerHTML={createMarkup(text.description)}
                    />
                    <Button
                        text={text.buttonText}
                        isDisabled={surveyData.surveyReason === '' && !surveyData.surveyReasonText}
                        overrideStyles={`
                            button {
                                border-radius: 10px;
                                padding: 16px 24px;
                                box-shadow: none;
                                letter-spacing: 0.33px;
                                font-weight: 500;
                                width: auto;
                            }
                        `}
                    />
                </div>
            </form>
        </div>
    )
}

export default SurveyUinstall
